/* Cuz Race Cars — GT3 cursor + skid trail. Enqueue after the DOM in theme.liquid.
   Reads the loader's .car SVG markup, so keep the loader markup on the page
   (or hard-code the SVG here). Touch devices are excluded automatically. */
(function(){
  var isDesktopMouse = matchMedia('(pointer:fine)').matches && matchMedia('(hover: hover)').matches;
  var isTouchOnly = matchMedia('(any-pointer: coarse)').matches && !matchMedia('(any-pointer: fine)').matches;
  if(!isDesktopMouse || isTouchOnly || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.body.classList.add('gt3');
  var tmpl = document.querySelector('#loader .car');
  if(!tmpl){ return; }   /* fail safe: no loader markup on the page, no cursor */
  var cur = document.createElement('div'); cur.id = 'gt3cur';
  cur.style.cssText = 'position:fixed;left:0;top:0;width:11px;height:21px;pointer-events:none;z-index:1200;opacity:0;transition:opacity .2s;will-change:transform';
  cur.innerHTML = '<svg viewBox="0 0 44 84" width="11" height="21" style="display:block">' + tmpl.innerHTML + '</svg>';
  document.body.appendChild(cur);
  var cv=document.createElement('canvas'); cv.id='skidcv';
  cv.style.cssText='position:fixed;left:0;top:0;pointer-events:none;z-index:1199';
  document.body.appendChild(cv);
  var ctx=cv.getContext('2d');
  function rs(){ cv.width=innerWidth; cv.height=innerHeight; }
  rs(); addEventListener('resize', rs);
  var trail=[], LIFE=260;              /* short life = only a small recent section shows */
  function drawFrame(){
    var now=performance.now();
    while(trail.length && now-trail[0].t>LIFE){ trail.shift(); }
    ctx.clearRect(0,0,cv.width,cv.height);
    ctx.lineWidth=2.5; ctx.lineCap='round';
    for(var i=1;i<trail.length;i++){
      var a=trail[i-1], b=trail[i];
      var dx=b.x-a.x, dy=b.y-a.y, L=Math.hypot(dx,dy);
      if(!L || L>140) continue;           /* skip teleports */
      var nx=-dy/L*3.5, ny=dx/L*3.5;      /* perpendicular offset = two tyres */
      /* fairly dark grey, mostly solid, only softens right at the tail end */
      var age=(now-b.t)/LIFE;
      var alpha=age<0.7 ? 0.8 : 0.8*(1-(age-0.7)/0.3);
      ctx.strokeStyle='rgba(50,54,61,'+alpha+')';
      ctx.beginPath();
      ctx.moveTo(a.x+nx,a.y+ny); ctx.lineTo(b.x+nx,b.y+ny);
      ctx.moveTo(a.x-nx,a.y-ny); ctx.lineTo(b.x-nx,b.y-ny);
      ctx.stroke();
    }
  }
  (function loop(){ drawFrame(); requestAnimationFrame(loop); })();
  var lx=-1, ly=-1, ang=0, dist=0;
  document.addEventListener('mousemove', function(e){
    if(lx>=0){
      var dx=e.clientX-lx, dy=e.clientY-ly, step=Math.hypot(dx,dy);
      if(step>2){
        var target = Math.atan2(dy,dx)*180/Math.PI + 90;
        var delta = ((target-ang+540)%360)-180;   /* shortest turn */
        ang += delta*0.4;                          /* smooth steering */
      }
    }
    cur.style.transform = 'translate('+(e.clientX-5)+'px,'+(e.clientY-10)+'px) rotate('+ang+'deg)';
    cur.style.opacity = '1';
    trail.push({x:e.clientX, y:e.clientY, t:performance.now()});
    drawFrame();
    lx=e.clientX; ly=e.clientY;
  }, {passive:true});
})();
